import type { CommandSource } from '../game/CommandSource';
import type { Command, CommandDraft } from '../sim/commands';
import type { LockstepSession } from './LockstepSession';

/*
 * מקור הפקודות של משחק רשת.
 *
 * **כל מה שיש כאן הוא הדבקה** — בדיוק כמו ב-`AiCommandSource`. ההנהלה יושבת
 * ב-`LockstepSession`; המחלקה הזו קיימת כדי שה-`GameLoop` לא ידע שיש הבדל בין
 * משחק מקומי למשחק ברשת. זה מה שהאבסטרקציה `CommandSource` הבטיחה מהיום הראשון,
 * וזו הנקודה שבה מתברר אם ההבטחה הייתה אמיתית.
 *
 * **הבדל אחד ויחיד מ-`LocalCommandSource`:** `ready` יכולה להחזיר false. שם היא
 * תמיד true כי אין למי לחכות.
 *
 * שימו לב ש-`issue` מקבלת גם את פקודות **השחקן המקומי**: ברשת הן עוברות באותו
 * מסלול בדיוק כמו של היריב, ומתבצעות אצל שנינו באותו טיק. פקודה מקומית שהייתה
 * "נחסכת" מהמסלול הזה הייתה הדבר הראשון שמפצל את המשחק.
 */
export class NetworkCommandSource implements CommandSource {
    constructor(private readonly session: LockstepSession) {}

    /** מוסיף פקודה מקומית לתור הרשת. מחזיר את הטיק שבו היא תתבצע בשני הצדדים. */
    issue(draft: CommandDraft, currentTick: number): number {
        return this.session.issue(draft, currentTick);
    }

    drain(tick: number): Command[] {
        return this.session.drain(tick);
    }

    ready(tick: number): boolean {
        return this.session.ready(tick);
    }
}
